module.exports = __webpack_public_path__ + "img/fIg_arzt.b12578db.png";